import fetchAPI from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { UNASSIGNED_ASSET_JOB_ID } from '../../utils/constants';
import { parseError } from '../../utils/fetchErrorParser';
import store from '../store';
import * as ENVIRONMENT from '../../shared/config/config';
import { enqueueSnackbar } from './snackbar';
import { VERSION } from 'lodash';

export const listJobs =
  (payload) =>
    (dispatch) => {
      dispatch({
        type: REDUX_ACTIONS.JOBS_LIST_LOADING,
      });

      const body = {
        collectionName: 'Jobs',
        query: {
          searchValue: payload?.searchValue || null,
          startDate: payload?.startDate || null,
          endDate: payload?.endDate || null
        }
      };

      return fetchAPI
        .post('jobs/jobs', body)
        .then((result) => {
          if (!result.ok) {
            return Promise.reject(result);
          }
          return result.json();
        })
        .then((data) => {
          dispatch({
            type: REDUX_ACTIONS.JOBS_LIST_SUCCESS,
            payload: {
              data: data.data.sort((a, b) => {
                if (a.active !== b.active) {
                  return a.active ? -1 : 1;
                }
                if (a.isFavorite !== b.isFavorite) {
                  return a.isFavorite ? -1 : 1;
                }
                if (a.isFavorite && b.isFavorite) {
                  return a.Rig.localeCompare(b.Rig, undefined, { sensitivity: 'base' });
                }
                return new Date(b.latestTimestamp) - new Date(a.latestTimestamp);
              }),
              paginatedElements: data.data.length,
            },
          });
        })
        .catch(async (error) => {
          const errorMessage = await parseError(error);
          dispatch(
            enqueueSnackbar(
              errorMessage,
              'error',
              new Date().getTime() + Math.random()
            )
          );
          dispatch({
            type: REDUX_ACTIONS.JOBS_LIST_ERROR,
            payload: { ...error, message: 'Error' },
          });
        });
    };

export const addNewJob = () => (dispatch) => {
  const { jobs } = store.getState();
  const newJobs = [...jobs.data];
  const nextId = newJobs.length - 1;

  function generateRandom() {
    const length = 24;
    const charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let retVal = '';
    for (let i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  const newRow = {
    Operator: '',
    Well: '',
    Location: '',
    Latitude: 0,
    Longitude: 0,
    Rig: '',
    Equipment: '',
    CompanyId: [],
    assets: [],
    systemStatus: null,
    data: '',
    lastUpdate: new Date(),
    grid_id: nextId + 1,
    _id: generateRandom(),
    isNewRow: true,
    isFavorite: false,
    active: false
  };
  newJobs.unshift(newRow);

  dispatch({
    type: REDUX_ACTIONS.JOBS_LIST_SUCCESS,
    payload: {
      data: newJobs,
      paginatedElements: newJobs.length,
    },
  });
};

export const createNewJob = (body) => (dispatch) => {
  const input = {
    job: {
      Operator: body?.Operator,
      Well: body?.Well,
      wellsInfoId: body?.wellsInfoId,
      Latitude: body?.Latitude,
      Longitude: body?.Longitude,
      Rig: body?.Rig,
      Location: body?.Location || 'NA',
      Equipment: body?.Equipment || 'NA',
      CompanyId: body?.CompanyId || 'NA',
      isFavorite: body?.isFavorite,
      active: body?.active
    },
  };
  return fetchAPI
    .post('jobs/job-create', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(listJobs());
      dispatch(
        enqueueSnackbar(
          'Job Added Successfully.',
          'success',
          new Date().getTime() + Math.random()
        )
      );
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
    });
};

export const updateJobDetails = (body) => (dispatch) => {
  const input = {
    job: {
      Operator: body?.Operator,
      Well: body?.Well,
      wellsInfoId: body?.wellsInfoId,
      Latitude: body?.Latitude,
      Longitude: body?.Longitude,
      Rig: body?.Rig,
      Location: body?.Location || 'NA',
      Equipment: body?.Equipment || 'NA',
      CompanyId: body?.CompanyId || 'NA',
      isFavorite: body?.isFavorite,
      active: body?.active
    },
    jobId: body?._id
  };
  return fetchAPI
    .put('jobs', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(listJobs());
      dispatch(
        enqueueSnackbar(
          'Job Updated Successfully.',
          'success',
          new Date().getTime() + Math.random()
        )
      );
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
    });
};

export const getJobById = (jobId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.JOBS_LIST_LOADING,
  });

  const body = {
    collectionName: 'Jobs',
    jobId,
  };

  return fetchAPI
    .post('jobs/jobs', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.JOBS_LIST_SINGLE_ITEM_SUCCESS,
        payload: {
          data: data.data,
          paginatedElements: data.data.length,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.JOBS_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const getJobAssets = (jobId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.JOB_ASSETS_LIST_LOADING,
  });

  const body = { jobId };

  return fetchAPI
    .post('assets/assets', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.JOB_ASSETS_LIST_SUCCESS,
        payload: {
          data: data.data,
          paginatedElements: data.data.length,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );

      dispatch({
        type: REDUX_ACTIONS.JOB_ASSETS_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const assignJobAssets = (jobId, assets) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.JOB_ASSETS_SAVING,
  });

  const assetsIds = assets.map((asset) => asset._id);

  const body = { assets: {} };
  body.assets[jobId] = assetsIds;

  return fetchAPI
    .put('assets/assets', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      if (result.status === 204) {
        return Promise.resolve();
      }
      return result.json();
    })
    .then(() => {
      if (jobId !== UNASSIGNED_ASSET_JOB_ID) {
        dispatch({
          type: REDUX_ACTIONS.JOB_ASSETS_SAVE_SUCCESS,
          payload: {
            data: assets,
          },
        });
        dispatch({
          type: REDUX_ACTIONS.ASSETS_SAVE_JOB_ASSET_SUCCESS,
          payload: {
            data: assetsIds,
          },
        });
      } else {
        dispatch({
          type: REDUX_ACTIONS.JOB_ASSETS_REMOVE_SUCCESS,
          payload: {
            data: assetsIds,
          },
        });
        dispatch({
          type: REDUX_ACTIONS.ASSETS_REMOVE_JOB_ASSET_SUCCESS,
          payload: {
            data: assets,
          },
        });
      }
      dispatch(listJobs());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );

      dispatch({
        type: REDUX_ACTIONS.JOB_ASSETS_SAVE_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const listSignalsData = (jobId) => (dispatch) => {
  const body = {
    jobId,
    input: { responseType: 'split' },
  };

  return fetchAPI
    .post('jobs/data', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.JOB_SIGNALS_DATA_LIST_SUCCESS,
        payload: {
          data: data.data,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );

      dispatch({
        type: REDUX_ACTIONS.JOB_SIGNALS_DATA_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const updateFavoriteJob = (payload) => (dispatch) => {
  const { type } = payload;
  dispatch({
    type: REDUX_ACTIONS.JOBS_LIST_LOADING,
  });
  const body = {
    input: {
      ...payload
    }
  };
  return fetchAPI
    .put('users/preferences/favoriteIds/jobsFavorites', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          type === 'add' ? 'Job added to favorites' : 'Job removed from favorites',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listJobs());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listJobs());
    });
};

export const exportJobAssets = (jobId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.JOB_ASSETS_LIST_LOADING,
  });

  const body = { jobId };

  const path = 'assets/downloadCSV';
  return fetchAPI
    .post(path, body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((data) => {
      // Convert JSON data to CSV format
      const blob = new Blob([data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'POT_Assets.csv';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);

      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.JOB_ASSETS_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};

export const syncJobs = (setSyncCompleted) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.JOBS_SYNC_LOADING,
    payload: {
      message: 'Please wait...',
    },
  });

  return fetchAPI
    .post('jobs/appJobsSync')
    .then(async (data) => {
      await dispatch(listJobs());
      dispatch({
        type: REDUX_ACTIONS.JOBS_SYNC_IDLE,
        payload: {
          message: 'Sync Completed' || data.message,
        },
      });
      setSyncCompleted(true);
    })
    .catch(async (error) => {
      dispatch(
        enqueueSnackbar(
          error.message || 'Error syncing mobile devices',
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.JOBS_SYNC_ERROR,
        payload: {
          message: 'Error syncing mobile devices' || error.message,
        },
      });
      setSyncCompleted(false);
    });
};

export const updateActiveJob = (payload) => (dispatch) => {
  const { active, _id } = payload;
  dispatch({
    type: REDUX_ACTIONS.JOBS_LIST_LOADING,
  });
  const body = {
    query: {
      _id
    },
    input: {
      active
    }
  };
  return fetchAPI
    .put('jobs/active-job', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          active ? 'Job Activated' : 'Job Deactivated',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listJobs());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listJobs());
    });
};

export const downloadSSLCertificate = (payload) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.SSL_GENERATE_LOADING,
  });
  const body = {
    input: {
      serialNum: payload
    }
  };
  return fetchAPI
    .downloadPost('sslExternals/generateDownload/proFlow', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.blob();
    })
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);

      const fileName = `${payload}_proflow_ssl_files.zip`;

      // Create an anchor element and set the download attribute
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;

      // Append the link to the document, click it, and remove it
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      dispatch({
        type: REDUX_ACTIONS.SSL_GENERATE_IDLE,
      });
      dispatch(
        enqueueSnackbar(
          'SSL Certificate Downloaded Successfully.',
          'success',
          new Date().getTime() + Math.random()
        )
      );
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch({
        type: REDUX_ACTIONS.SSL_GENERATE_IDLE,
      });
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
    });
};

export const jobActuatorDataCsvUpload = (csv, id, setIsLoading, handleUploadSuccess) => async (dispatch) => {
  const formData = new FormData();
  const { currentUser } = store.getState();
  const BASE_URL = ENVIRONMENT.API_URL;
  const payload = {
    query: {
      jobId: id,
    },
    user: {
      type: currentUser.type,
      companyId: currentUser.companyId,
      userId: currentUser.userId,
      version: VERSION
    }
  };
  formData.append('file', csv);
  formData.append('payload', JSON.stringify(payload));
  setIsLoading(true);
  try {
    const response = await fetch(`${BASE_URL}jobs/importCSV`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    });
    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.message);
    }
    setIsLoading(false);
    handleUploadSuccess();
  } catch (error) {
    setIsLoading(false);
    dispatch(
      enqueueSnackbar(
        error.message || error || 'Error uploading file',
        'error',
        new Date().getTime() + Math.random()
      )
    );
    return Promise.reject(error);
  }
};

export const fetchJobsActuatorUtilization = (jobId, monthStartEndDates, signal) => (dispatch) => {
  const month = String(monthStartEndDates.endDate.getMonth() + 1).padStart(2, '0');
  const year = monthStartEndDates.endDate.getFullYear();
  dispatch({
    type: REDUX_ACTIONS.JOBS_ACTUATOR_UTILIZATION_DATA_LOADING,
  });
  const body = {
    query: {
      jobId,
      ...monthStartEndDates
    },
  };

  return fetchAPI
    .post('jobs/actuatorUtilization', body, {}, signal)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.JOBS_ACTUATOR_UTILIZATION_DATA_SUCCESS,
        payload: {
          data: data.data,
          dataForMonth: `${month}/${year}`
        },
      });
    })
    .catch(async (error) => {
      dispatch({
        type: REDUX_ACTIONS.JOBS_ACTUATOR_UTILIZATION_DATA_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};
